import {useEffect, useState} from "react";
import Loading from "../../../../component/Loading/Loading";
import TextInput from "../../../../component/TextInput/TextInput";
import {uploadInformationPictures} from "../../../Products/functions";
import {listToTree, toastSuccess} from "../../../../assets/functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import ImageInput from "../../../../component/ImageInput/ImageInput";
import TextEditor, {TextEditorWithoutContainer} from "../../../../component/TextEditor/TextEditor";
import {uploadNewsTextPictures} from "../../functions";
import {baseImagesUrl} from "../../../../assets/Constants";
import uploadPlaceholder from "../../../../assets/upload-file.svg";
import {getAllNewsCategoriesObject} from "../../../NewsCategories/functions";
import TreeSelect from "../../../../component/TreeSelect/TreeSelect";
import InputFileBase64 from "../../../../component/InputFileBase64/InputFileBase64";

const NewsForm = ({news, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allNewsCategory, setAllNewsCategory] = useState([]);
    const [tempValues , setTempValues] = useState({
        newsPictures : [],
    })

    useEffect(() => {
        (async () => {
            const newsCategory = await getAllNewsCategoriesObject();
            setAllNewsCategory(newsCategory);
            setIsLoading(false);
        })();

    }, []);

    const changeTempValues = (key , value) => {
        const newTempValues = {...tempValues , [key] : value};
        setTempValues(newTempValues);
    }
    const changeNews = (key , value) => {
        const newNews = {...news , [key] : value};
        onChange(newNews);
    }


    if (isLoading)
        return <Loading/>

    return (
        <div className={"row"}>
            <div className="col-12">
                <TextInput label={"عنوان خبر"} value={news.title} onChange={(value) => {
                    changeNews("title", value);
                }}/>
            </div>
            <div className="col-12">
                <TextInput label={"خلاصه خبر"} value={news.summary} onChange={(value) => {
                    changeNews("summary", value);
                }}/>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2">متن خبر</label>
                        <div className="row">
                            {
                                tempValues.newsPictures.map((picture, index) => {
                                    return (<div key={index} className="col-md-2">
                                        <img
                                            className={`w-100 productImage`}
                                            src={picture}
                                        />
                                        {!picture.includes("news_text_picture") &&
                                            <button className={"btn btn-success w-100"} onClick={async () => {
                                                const imageUrl = await uploadNewsTextPictures(picture);
                                                const newTempValuesPicture = tempValues.newsPictures;
                                                newTempValuesPicture[index] = imageUrl;
                                                changeTempValues("newsPictures", newTempValuesPicture);
                                            }}>
                                                آپلود
                                            </button>}
                                        {picture.includes("news_text_picture") &&
                                            <button className={"btn btn-success w-100"} onClick={async () => {
                                                toastSuccess("لینک کپی شد!");
                                                navigator.clipboard.writeText(picture)
                                            }
                                            }>
                                                <FontAwesomeIcon icon={faCopy}/>
                                                {picture}
                                            </button>}
                                    </div>)
                                })
                            }
                            <div className="col-md-2">
                                <ImageInput aspect={5 / 3} onChange={(value) => {
                                    const newTempPictures = [...tempValues.newsPictures, value];
                                    changeTempValues("newsPictures", newTempPictures)
                                }}/>
                            </div>
                        </div>
                        <TextEditorWithoutContainer value={news.text} onChange={(value) => {
                            changeNews("text", value)
                        }}/>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <label className="card-title mb-2">تصاویر</label>
                            {
                                news.pictures.map((picture, index) => {
                                    return (<div key={index} className="col-md-2">
                                        <img
                                            className={`w-100 productImage ${picture == news.primaryPicture ? "border border-2 border-success" : ""}`}
                                            src={picture.includes("news_") ? `${baseImagesUrl}news/${picture}` : picture}
                                            onDoubleClick={() => {
                                                changeNews("primaryPicture", picture)
                                            }}
                                        />
                                        <button className={"btn btn-danger w-100"} onClick={() => {
                                            const newPictures = news.pictures.filter((p) => {
                                                if (picture != p) {
                                                    return p;
                                                }
                                            });
                                            changeNews("pictures", newPictures);
                                            if (news.primaryPicture == picture)
                                                changeNews("primaryPicture", "");

                                        }}>حذف
                                        </button>
                                    </div>)
                                })
                            }
                            <div className="col-md-2">
                                <ImageInput aspect={5 / 4} defaultPic={uploadPlaceholder} onChange={(value) => {
                                    const newPictures = [...news.pictures, value];
                                    changeNews("pictures", newPictures)
                                }}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <label className="card-title mb-2">ویدئو</label>
                            {
                                news.videos.map((video, index) => {
                                    return (<div key={index} className="col-md-2">
                                            <video className={"w-100"} controls>
                                                <source
                                                    src={video.includes("news") ? `${baseImagesUrl}news/${video}` : video}
                                                    type="video/mp4"/>
                                                <source
                                                    src={video.includes("news") ? `${baseImagesUrl}news/${video}` : video}
                                                    type="video/ogg"/>
                                                Your browser does not support the video tag.
                                            </video>

                                            <button className={"btn btn-danger w-100"} onClick={() => {
                                                const newVideos = news.videos.filter((v, i) => {
                                                    if (index != i) {
                                                        return v;
                                                    }
                                                });
                                                changeNews("videos", newVideos);
                                            }}>حذف
                                            </button>
                                        </div>
                                    )
                                })
                            }
                            <div className="col-md-2">
                                <InputFileBase64 onChange={(value) => {
                                    const newVideos = [...news.videos, value];
                                    changeNews("videos", newVideos);
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-12">
                <TreeSelect label={"دسته بندی خبر"} data={listToTree(allNewsCategory, news.newsCategoryIds)}
                            onChange={(value) => {
                                changeNews("newsCategoryIds", value)
                            }}
                />
            </div>

            <div className="col-md-2">
                <TextInput label={"زمان مطالعه"} value={news.readTime} onChange={(value) => {
                    changeNews("readTime", value);
                }}/>
            </div>
            <div className="col-md-4">
                <TextInput label={"منبع"} value={news.source} onChange={(value) => {
                    changeNews("source", value);
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"لینک منبع"} value={news.sourceLink} onChange={(value) => {
                    changeNews("sourceLink", value);
                }}/>
            </div>
        </div>
    );
}

export default NewsForm;